import { ILabel } from '../../../models/common/label.model';

export type QuickOrderByStockProduct = { key: number; stockNo: string; qty?: number };

export type QuickAddProductsByStockProps = {
  labels: ILabel[];
  isSearchByStockCodeOnly?: boolean;
  isDisabled?: boolean;
  isResetting?: boolean;
  onProductsUpdateCallback?: (updatedProducts: QuickOrderByStockProduct[]) => void;
};

export type State = {
  products: QuickOrderByStockProduct[];
  lastUpdatedProducts: QuickOrderByStockProduct[];

  tempProducts: QuickOrderByStockProduct[];
  newValue: string;
  newQuantity?: number;

  //to control tab after new product is added
  tabPressed: boolean;
  newProductJustAdded: boolean;
  isNewQtyFocused: boolean;
};

export enum QuickAddProductsByStockActionType {
  SetLastUpdatedProducts = 'SetLastUpdatedProducts',
  UpdateProductsWithTemp = 'UpdateProductsWithTemp',
  UpdateExistingProduct = 'UpdateExistingProduct',
  AddNewProduct = 'AddNewProduct',
  UpdateNewProductInputs = 'UpdateNewProductInputs',
  FocusNewProduct = 'FocusNewProduct',
  TabPress = 'TabPress',
  NewQtyFocused = 'NewQtyFocused',
  Reset = 'Reset',
}

export type Action =
  | { type: QuickAddProductsByStockActionType.SetLastUpdatedProducts }
  | { type: QuickAddProductsByStockActionType.UpdateProductsWithTemp }
  | { type: QuickAddProductsByStockActionType.UpdateExistingProduct; productKey: number; stockNo?: string; qty?: number }
  | { type: QuickAddProductsByStockActionType.AddNewProduct }
  | { type: QuickAddProductsByStockActionType.UpdateNewProductInputs; inputType: 'value' | 'qty'; input: string }
  | { type: QuickAddProductsByStockActionType.FocusNewProduct }
  | { type: QuickAddProductsByStockActionType.TabPress }
  | { type: QuickAddProductsByStockActionType.NewQtyFocused; isFocused: boolean }
  | { type: QuickAddProductsByStockActionType.Reset };
